var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    color: "#0a53be",
    opacity: 0.8,
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "users-class",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    className: "svg-inline--fa fa-users-class fa-w-20 fa-lg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-group"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M608 217a95.26 95.26 0 0 0-64-25V64H96v128a95.28 95.28 0 0 0-64 25V49.59C32 22.25 53.53 0 80 0h480c26.47 0 48 22.25 48 49.59z",
    className: "fa-secondary"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M576 384h-64a64 64 0 0 0-64 64v32a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32v-32a64 64 0 0 0-64-64zm-32-32a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm-192 32h-64a64 64 0 0 0-64 64v32a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32v-32a64 64 0 0 0-64-64zm-224 0H64a64 64 0 0 0-64 64v32a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32v-32a64 64 0 0 0-64-64zm192-32a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm-224 0a64 64 0 1 0-64-64 64 64 0 0 0 64 64z",
    className: "fa-primary"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.4c1267877063e1df82cc1ec3b5fe1f46.svg";
export { ForwardRef as ReactComponent };